import AccordionCore from '@studiometa/js-toolkit/components/Accordion/index';
import withBreakpointObserver from '@studiometa/js-toolkit/decorators/withBreakpointObserver';

/**
 * Class
 */
export default class Accordion extends withBreakpointObserver(AccordionCore) {
  /**
   * Config
   */
  get config() {
    return {
      ...(super.config || {}),
      activeBreakpoints: 'xxs xs s',
      name: 'AccordionFooter',
    };
  }
}
